<template>
  <HeadlessInput v-bind="inputProps" @update:model-value="handleUpdate" @blur="handleBlur" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import HeadlessInput from '@/components/atoms/HeadlessInput.vue'

interface Props {
  modelValue: string | number
  label?: string
  type?: 'text' | 'email' | 'tel' | 'password' | 'number' | 'date'
  placeholder?: string
  disabled?: boolean
  readonly?: boolean
  required?: boolean
  error?: string | undefined
  hint?: string
  id?: string
  maxlength?: number
  variant?: 'default' | 'surface'
}

const props = withDefaults(defineProps<Props>(), {
  type: 'text',
  disabled: false,
  readonly: false,
  required: false,
  variant: 'default',
})

const emit = defineEmits<{
  'update:modelValue': [value: string | number]
  blur: []
}>()

const inputProps = computed(() => {
  const baseProps: {
    modelValue: string | number
    type: 'text' | 'email' | 'tel' | 'password' | 'number' | 'date'
    disabled: boolean
    readonly: boolean
    required: boolean
    variant?: 'default' | 'surface'
    label?: string
    placeholder?: string
    error?: string
    hint?: string
    id?: string
    maxlength?: number
  } = {
    modelValue: props.modelValue,
    type: props.type,
    disabled: props.disabled,
    readonly: props.readonly,
    required: props.required,
    variant: props.variant,
  }

  if (props.label !== undefined) {
    baseProps.label = props.label
  }
  if (props.placeholder !== undefined) {
    baseProps.placeholder = props.placeholder
  }
  if (props.error !== undefined) {
    baseProps.error = props.error
  }
  if (props.hint !== undefined) {
    baseProps.hint = props.hint
  }
  if (props.id !== undefined) {
    baseProps.id = props.id
  }
  if (props.maxlength !== undefined) {
    baseProps.maxlength = props.maxlength
  }

  return baseProps
})

const handleUpdate = (value: string | number): void => {
  emit('update:modelValue', value)
}

const handleBlur = (): void => {
  emit('blur')
}
</script>
